
import { useRole } from "../MangeContextProvide";

export const AirIcon = () => (
    <svg width="22" height="22" viewBox="0 0 64 64" fill="none">
        <path
            d="M32 8 C34 8 36 10 36 13 L38 32 L54 40 L54 44 L38 40 L39 50 L44 53 L44 56 L32 53 L20 56 L20 53 L25 50 L26 40 L10 44 L10 40 L26 32 L28 13 C28 10 30 8 32 8 Z"
            fill="currentColor" opacity="0.13" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
        />
        <rect x="19" y="36" width="8" height="3" rx="1.5" fill="currentColor" opacity="0.25" stroke="currentColor" strokeWidth="1.1" />
        <rect x="37" y="36" width="8" height="3" rx="1.5" fill="currentColor" opacity="0.25" stroke="currentColor" strokeWidth="1.1" />
        <circle cx="32" cy="20" r="1.2" fill="currentColor" opacity="0.5" />
        <circle cx="32" cy="25" r="1.2" fill="currentColor" opacity="0.4" />
        <circle cx="32" cy="30" r="1.2" fill="currentColor" opacity="0.3" />
    </svg>
);

export const OceanIcon = () => (
    <svg width="22" height="22" viewBox="0 0 64 64" fill="none">
        <path d="M8 36 L12 44 Q32 50 52 44 L56 36 Z" fill="currentColor" opacity="0.13" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <rect x="18" y="28" width="28" height="8" rx="1" stroke="currentColor" strokeWidth="1.4" fill="none" />
        <rect x="21" y="22" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.3" fill="currentColor" opacity="0.12" />
        <rect x="31" y="22" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.3" fill="currentColor" opacity="0.12" />
        <rect x="26" y="16" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.3" fill="currentColor" opacity="0.1" />
        <rect x="40" y="20" width="3" height="8" rx="1" stroke="currentColor" strokeWidth="1.2" fill="none" />
        <path d="M4 48 Q10 45 16 48 Q22 51 28 48 Q34 45 40 48 Q46 51 52 48 Q58 45 62 48" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none" opacity="0.4" />
    </svg>
);

const ServiceTypeToggle = ({ onTypeChange, activeTab, width = "100%" }: any) => {
    const { module }: any = useRole();

    const modules = module || [];
    const showWAAndAWBCredits = modules.includes("1");
    const showContainerCredits = modules.includes("2");

    const handleTypeChange = (value: string) => {
        onTypeChange(value);
    };

    return (

        <div className="atd-toggle-wrap"
            style={{ width }}
        >
            <div className={`atd-toggle-slider${activeTab === "ocean" ? " ocean" : ""}`} />
            {showWAAndAWBCredits && <button className={`atd-toggle-btn${activeTab === "air" ? " active" : ""}`} onClick={() => handleTypeChange("air")}>
                <span className="atd-toggle-icon"><AirIcon /></span>
                <span className="atd-toggle-label-col">
                    <span>Air</span>
                    <span className="atd-toggle-sub">AWB Number</span>
                </span>
            </button>}
            {showContainerCredits && <button className={`atd-toggle-btn${activeTab === "ocean" ? " active" : ""}`} onClick={() => handleTypeChange("ocean")}>
                <span className="atd-toggle-icon"><OceanIcon /></span>
                <span className="atd-toggle-label-col">
                    <span>Ocean</span>
                    <span className="atd-toggle-sub">BL · BK · CT</span>
                </span>
            </button>}
        </div>

    );
};

export default ServiceTypeToggle;